import React        from 'react';
import renderHTML   from 'react-render-html';

class PckInclusions extends React.Component {
	render() {
		if (this.props.children !== null) {
			let inc = this.props.children.replace('<ul>', '<ul class="house-includes-list">');
			return (
                <div className="p-a-1 brd-top">
                	<p className="m-b-1 small-blue-font tc tl-lg">INCLUDES:</p>
                    {renderHTML(inc)}
				</div>
			)
		} else {
			return (<div/>);
		}
	}
}

export default PckInclusions;



/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PckInclusions.js
 **/